module.exports = __webpack_public_path__ + "static/media/blob.bde159e3.svg";